export default {
  guest: {
    earn_pts: 'Gagnez {{points}} pts sur cette commande',
    tagline: 'Soyez récompensé. Chaque commande, à chaque fois.',
    pick_reward: 'Choisissez ce que vous voulez quand vous y êtes',
    free_at: 'gratuit à {{points}} pts',
    save_at: 'économisez {{amount}} à {{points}} pts',
    nearest: 'le plus proche',
    cta: "Commencez à gagner — c'est gratuit",
    already_member: 'Déjà membre ?',
    sign_in: 'Se connecter',
  },
  member: {
    earning_free: 'Vous gagnez de la nourriture gratuite',
    every_euro_one: 'Chaque {{amount}} dépensé = 1 pt. Échangez contre des articles gratuits et des réductions.',
    every_euro_other:
      'Chaque {{amount}} dépensé = {{count}} pts. Échangez contre des articles gratuits et des réductions.',
    until_redeem: '{{remaining}} pts avant de pouvoir commencer à échanger',
    unlock_first: 'Cette commande seule débloque votre première récompense !',
    so_close: 'Tout près de la nourriture gratuite !',
    just_more: 'Plus que {{remaining}} pts pour commencer à économiser.',
    pts_to_unlock: '{{remaining}} pts pour débloquer les récompenses',
    this_order_unlocks: 'Cette commande vous amène à {{points}} pts — vous pouvez échanger à la prochaine commande !',
    save_next: "Économisez jusqu'à {{amount}} la prochaine fois",
    pts_from_order: '+{{earned}} pts de cette commande — plus que {{remaining}} restants !',
    rewards_value: '= {{amount}} en récompenses',
    save_this_order: "Économisez jusqu'à {{amount}} sur cette commande",
    use_pts: 'Utilisez vos {{points}} pts au paiement',
    earned_this_order: '+{{points}} pts gagnés sur cette commande',
    current: 'Actuel',
    from_this_order: '+{{points}} de cette commande',
    expiration_zero: "{{points}} pts expirent aujourd'hui",
    expiration_one: '{{points}} pts expirent dans 1 jour',
    expiration_other: '{{points}} pts expirent dans {{count}} jours',
  },
};
